import AppContext from 'App/AppContext';
import { IPScrollablePane } from 'baseComponents';
import { IPScrollbarVisibility } from 'baseComponents/ScrollablePane/IPScrollablePane';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalNavBarHeight } from 'globalConstants';
import { ReactNode, useContext } from 'react';

export interface IScrollableStackItem {
  isOnPanel?: boolean;
  height?: number; //percentage of available scene height
  minHeight?: number; //min height in px
  maxHeight?: number; //percentage of available scene height
  extraFixedMargin?: number;
  disableScroll?: boolean;
  isScrollParent?: boolean; //marks this element as the scroll container for virtualized Fluent lists (isOnPanel only)
}

interface IScrollableStackItemProps extends IScrollableStackItem {
  children: ReactNode;
}

const ScrollableStackItem = (props: IScrollableStackItemProps) => {
  const appContext = useContext(AppContext);

  const setScrollableHeight = (windowHeight: number, requiredHeight: number, extraFixedMargin?: number) => {
    let fixedMargin = globalNavBarHeight; //fixed margin for top nav bar
    fixedMargin += 52; //fixed margin for panel title
    fixedMargin += 100; //fixed margin for panel footer
    fixedMargin += extraFixedMargin || 0; //context specific margin

    const height = (windowHeight - fixedMargin) * (requiredHeight / 100);

    return `${height}px`;
  };

  if (props.disableScroll === true) {
    return (
      <IPStack.Item
        grow
        styles={{
          root: {
            height: props.height,
            minHeight: props.minHeight,
            maxHeight: props.maxHeight,
            overflowY: 'hidden',
            overflowX: 'hidden',
          },
        }}
      >
        {props.children}
      </IPStack.Item>
    );
  } else if (props.isOnPanel === true) {
    const height = setScrollableHeight(appContext.windowHeight, props.height || 20, props.extraFixedMargin);
    const maxHeight = props.maxHeight
      ? setScrollableHeight(appContext.windowHeight, props.maxHeight, props.extraFixedMargin)
      : undefined;

    return (
      <IPStack.Item
        id="scrollableStackItem"
        data-is-scrollable={props.isScrollParent ? true : undefined}
        grow
        styles={{
          root: {
            height: height,
            minHeight: props.minHeight,
            maxHeight: maxHeight,
            overflowY: 'scroll',
            overflowX: 'hidden',
          },
        }}
      >
        {props.children}
      </IPStack.Item>
    );
  } else {
    return (
      <IPStack.Item
        grow
        styles={{
          root: { minHeight: props.minHeight, position: 'relative' },
        }}
      >
        <IPScrollablePane scrollbarVisibility={IPScrollbarVisibility.auto}>{props.children}</IPScrollablePane>
      </IPStack.Item>
    );
  }
};

export default ScrollableStackItem;
